const styles = (theme) => ({
  contentWrapper: {
    padding: '34px 0px',
    '@media(max-width: 767px)': {
      padding: '24px 0px',
    },
  },
  titleWrapper: {
    marginBottom: 40,
    '@media(max-width: 767px)': {
      marginBottom: 20,
    },
  },
  title: {
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize32,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1,
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize20,
    },
  },
  cardWrapper: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize16,
    padding: 32,
    boxShadow: '0px 2px 8px rgb(0 0 0 / 5%)',
    borderRadius: 8,
    maxWidth: 830,
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize14,
      backgroundColor: 'transparent',
      padding: 0,
      boxShadow: 'none',
      borderRadius: 0,
    },
    '& p': {
      marginTop: '0.5em',
      marginBottom: '0.5em',
    },
    '& h5': {
      color: theme.palette.common.blue400,
      fontSize: theme.typography.fontSize18,
      '@media(max-width: 767px)': {
        fontSize: theme.typography.fontSize16,
      },
    },
    '& ul, & ol': {
      paddingLeft: '2em',
    },
    '& hr': {
      marginTop: '2.5em',
      marginBottom: '2.5em',
      borderColor: theme.palette.common.grey20,
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      '@media(max-width: 767px)': {
        marginTop: '2em',
        marginBottom: '2em',
      },
    },
  },
});

export default styles;
